import { Pagination, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import Filters from '../../../components/Filters';
import Typograpy from '../../../components/Typograpy';
import Wrapper from '../../../components/Wrapper';
import {
  buttons,
  formProvinceData,
  formRegionData,
  formgroupData,
  formOrganizationData,
} from './helper';
import './style.css';
import { AddContainer } from '../Users/style';
import AddButton from '../../../components/AddButton';
import ActionButton from '../../../components/ActionButton';
import { useHideModal, useShowAlert, useShowModal } from '../../../hooks';
import FormCreator from '../../../components/FormCreator';
import Confirm from '../../../components/Confirm';
import provinceService from '../../../services/provinces';
import regionService from '../../../services/regions';
import groupService from '../../../services/groups';
import organizationService from '../../../services/organization';
import FullScreen from '../../../components/Spinner/FullScreen';

export default () => {
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const { success, error } = useShowAlert();
  const [active, setActive] = useState('province');
  const [bool, setBool] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [provinceData, setProvinceData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(0);

  const names = {
    province: 'Вилоят',
    region: 'Туман/шаҳар',
    group: 'Гуруҳ',
    organization: 'Ташкилот',
  };

  const formData = {
    province: formProvinceData,
    region: formRegionData,
    group: formgroupData,
    organization: formOrganizationData,
  };

  const selectOptions = {
    province: provinceData,
    region: provinceData,
    group: groupData,
  };

  const initialValuesAdd = (active) => {
    if (active == 'province' || active == 'group' || active == 'organization') {
      return {
        title: '',
        desc: '',
      };
    } else {
      return {
        title: '',
        desc: '',
        province: '',
      };
    }
  };

  const initialValuesEdit = (data, active) => {
    if (active == 'province' || active == 'group') {
      return {
        title: data.title,
        desc: data.desc,
      };
    } else if (active == 'organization') {
      return {
        title: data.title,
        desc: data.desc,
        group: data.group,
      };
    } else {
      return {
        title: data.title,
        desc: data.desc,
        province: data.province,
      };
    }
  };

  const handleActive = (item) => {
    setActive(item.value);
  };

  useEffect(() => {
    setLoading(true);
    if (active == 'province') {
      provinceService
        .getAll()
        .then((res) => {
          let provinces = res.map((item, index) => {
            return { ...item, key: index + 1 };
          });
          setData(provinces);
          setProvinceData(provinces);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (active == 'organization') {
      const data = {
        limit: size,
        page: page,
      };
      groupService
        .getAll()
        .then((res) => {
          setGroupData(res);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
      organizationService
        .getAll(data)
        .then((res) => {
          setTotal(res?.totalDocs);
          let organization = res.docs.map((item, index) => {
            return page == 1
              ? { ...item, key: index + 1 }
              : { ...item, key: (page - 1) * size + index + 1 };
          });
          setData(organization);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (active == 'region') {
      regionService
        .getAll()
        .then((res) => {
          let regions = res.map((item, index) => {
            return { ...item, key: index + 1 };
          });
          setData(regions);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      groupService
        .getAll()
        .then((res) => {
          let groups = res.map((item, index) => {
            return { ...item, key: index + 1 };
          });
          setData(groups);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [active, bool, page, size]);

  //Create section

  const sendProvinceData = (data) => {
    provinceService
      .create(data)
      .then(() => {
        success('Маълумот қўшилди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Вилоят қўшишда хатолик', 2, 'bottom');
      });
  };

  const sendgroupData = (data) => {
    groupService
      .create(data)
      .then(() => {
        success('Гуруҳ маълумот қўшилди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Гуруҳ қўшишда хатолик', 2, 'bottom');
      });
  };

  const sendRegionData = (data) => {
    regionService
      .create(data)
      .then(() => {
        success('Туман/шаҳар маълумот қўшилди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Туман/шаҳар қўшишда хатолик', 2, 'bottom');
      });
  };

  const sendOrganizationData = (data) => {
    organizationService
      .create(data)
      .then(() => {
        success('Маълумот қўшилди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Ташкилот қўшишда хатолик', 2, 'bottom');
      });
  };

  const sendData = (data) => {
    hideModal();
    setLoading(true);
    if (active == 'province') {
      return sendProvinceData(data);
    } else if (active == 'region') {
      return sendRegionData(data);
    } else if (active == 'organization') {
      return sendOrganizationData(data);
    } else {
      return sendgroupData(data);
    }
  };

  const addData = () => {
    showBlured({
      title: `${names[active]} qo'shish`,
      maxWidth: '600px',
      height: '400px',
      withHeader: false,
      body: () => (
        <FormCreator
          selectOptions={selectOptions}
          formData={formData[active]}
          initialVal={initialValuesAdd(active)}
          cancel={hideModal}
          sendData={sendData}
          id=''
        />
      ),
    });
  };

  //Update Section
  const updateProvinceData = (id, data) => {
    provinceService
      .update(id, data)
      .then(() => {
        success('Вилоят маълумоти янгиланди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Вилоят маълумотини янгилашда хатолик', 2, 'bottom');
      });
  };
  const updateOrganizationData = (id, data) => {
    organizationService
      .update(id, data)
      .then(() => {
        success('Ташкилот маълумоти янгиланди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Ташкилот маълумотини янгилашда хатолик', 2, 'bottom');
      });
  };

  const updategroupData = (id, data) => {
    groupService
      .update(id, data)
      .then(() => {
        success('Гуруҳ янгиланди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Гуруҳ янгилашда хатолик', 2, 'bottom');
      });
  };

  const updateRegionData = (id, data) => {
    regionService
      .update(id, data)
      .then(() => {
        success('Туман/шаҳар янгиланди', 2, 'bottom');
        setBool(!bool);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Туман/шаҳар янгилашда хатолик', 2, 'bottom');
      });
  };

  const updateData = (id, data) => {
    hideModal();
    setLoading(true);
    if (active == 'province') {
      return updateProvinceData(id, data);
    } else if (active == 'region') {
      return updateRegionData(id, data);
    } else if (active == 'organization') {
      return updateOrganizationData(id, data);
    } else {
      return updategroupData(id, data);
    }
  };

  const handleEdit = (data) => {
    showBlured({
      title: `${names[active]} qo'shish`,
      maxWidth: '600px',
      height: '400px',
      withHeader: false,
      body: () => (
        <FormCreator
          id={data._id}
          selectOptions={selectOptions}
          formData={formData[active]}
          cancel={hideModal}
          initialVal={initialValuesEdit(data, active)}
          sendData={updateData}
        />
      ),
    });
  };

  //Delete Section

  const deleteProvince = (id) => {
    provinceService
      .delete(id)
      .then(() => {
        setBool(!bool);
        success('Вилоят ўчирилди', 2, 'bottom');
      })
      .catch((err) => {
        console.log(err);
        success('Вилоят ўчиришда хатолик', 2, 'bottom');
      });
  };

  const deleteOrganization = (id) => {
    organizationService
      .delete(id)
      .then(() => {
        setBool(!bool);
        success('Ташкилот ўчирилди', 2, 'bottom');
      })
      .catch((err) => {
        console.log(err);
        success('Ташкилот ўчиришда хатолик', 2, 'bottom');
      });
  };

  const deleteRegion = (id) => {
    regionService
      .delete(id)
      .then(() => {
        setBool(!bool);
        success('Туман/шаҳар ўчирилди', 2, 'bottom');
      })
      .catch((err) => {
        console.log(err);
        success('Туман/шаҳар ўчиришда хатолик', 2, 'bottom');
      });
  };

  const deletegroup = (id) => {
    groupService
      .delete(id)
      .then(() => {
        setBool(!bool);
        success('Гуруҳ ўчирилди', 2, 'bottom');
      })
      .catch((err) => {
        console.log(err);
        success('Гуруҳ ўчиришда хатолик', 2, 'bottom');
      });
  };

  const deleteSection = (id) => {
    hideModal();
    setLoading(true);
    if (active == 'province') {
      deleteProvince(id);
    } else if (active == 'region') {
      deleteRegion(id);
    } else if (active == 'organization') {
      deleteOrganization(id);
    } else {
      deletegroup(id);
    }
  };
  const handleDelete = (_id) => {
    showBlured({
      title: "O'chirish",
      maxWidth: '400px',
      height: '300px',
      withHeader: false,

      body: () => (
        <Confirm agree={() => deleteSection(_id)} cancel={hideModal} />
      ),
    });
  };

  // Column table

  const columns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      width: '10%',
      align: 'center',
    },

    {
      title: 'Номи',
      dataIndex: 'title',
      key: 'title',
    },

    {
      width: '20%',
      align: 'center',
      title: 'Амал',
      dataIndex: '',
      key: 'x',
      render: (props) => (
        <ActionButton
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          props={props}
        />
      ),
    },
  ];

  const onChange = (page) => {
    setPage(page);
  };

  const onShowSizeChange = (current, pageSize) => {
    setPage(1);
    setSize(pageSize);
  };

  if (loading) return <FullScreen />;
  return (
    <Wrapper>
      <Filters list={buttons} active={active} handleActive={handleActive} />
      <AddContainer>
        <AddButton text={names[active]} addData={addData} />
      </AddContainer>
      <Typograpy>{names[active]}</Typograpy>
      <Table bordered columns={columns} dataSource={data} pagination={false} />
      {active == 'organization' && (
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
          <Pagination
            total={total}
            current={page}
            defaultPageSize={size}
            showSizeChanger
            onChange={onChange}
            onShowSizeChange={onShowSizeChange}
          />
        </div>
      )}
    </Wrapper>
  );
};
